export enum LeadStatus {
  All = 'ALL',
  New = 'NEW',
  Acquired = 'ACQUIRED',
  NotQualified = 'NOT_QUALIFIED',
}
